<template>
  <v-card
    color="grey lighten-4"
    :to="item.to"
    class="d-flex flex-column item"
    height="100%"
    flat
  >
    <div class="relative">
      <img
        :src="`//img.youtube.com/vi/${getYoutubeCode(
          item.video
        )}/hqdefault.jpg`"
        alt="Fotos e Eventos"
        class="d-block item-img"
      />
      <v-sheet
        width="40px"
        height="40px"
        color="rgba(255, 255, 255, 0.2)"
        class="d-flex align-center justify-center rounded-pill item-icon"
      >
        <v-icon color="white" size="18"> fa-play </v-icon>
      </v-sheet>
    </div>

    <div
      class="
        text-caption text-md-body-1
        grey--text
        text--darken-4
        font-weight-bold
        text-center
        px-3 px-sm-4
        py-3 py-sm-5
        my-auto
      "
    >
      <div class="item-title">
        {{ item.title }}
      </div>
    </div>
  </v-card>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getYoutubeCode,
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" })
        .format(new Date(date.replace(" ", "T")))
        .replaceAll(" de", "")
        .replaceAll(".", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 9;
    border-radius: 4px 4px 0 0;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-icon {
    left: 50%;
    margin-left: -20px;
    margin-top: -20px;
    position: absolute;
    top: 50%;
  }
  .item-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
